export const getEnvironmentVariable = (
  environmentVariable: string
): string | number | undefined => {
  // @ts-expect-error Ignore type any object error
  if (window?.['_env_'] && window?.['_env_'][environmentVariable]) {
    // @ts-expect-error Ignore type any object error
    return window['_env_'][environmentVariable];
  }

  if (import.meta.env.MODE === 'development') {
    if (import.meta.env['VITE_' + environmentVariable]) {
      return import.meta.env['VITE_' + environmentVariable];
    }
  }

  return undefined;
};

export const getEnvironmentBoolean = (environmentVariable: string): boolean | undefined => {
  const value = getEnvironmentVariable(environmentVariable);
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return undefined;
};

export const getEnvironmentNumber = (environmentVariable: string): number | undefined => {
  const value = getEnvironmentVariable(environmentVariable);
  if (value) {
    return typeof value === 'number' ? value : parseInt(value);
  }
  return undefined;
};

export const isMockFeatureEnabled = (feature: string): boolean => {
  const mocks = getEnvironmentVariable('MOCKS');

  if (mocks && typeof mocks === 'object') {
    const featureKey = Object.keys(mocks).find(key => key.toLowerCase() === feature.toLowerCase());

    if (featureKey) {
      const mockFeature = mocks[featureKey];
      return mockFeature === true || mockFeature === 'true';
    }
  }

  return false;
};

export const environment = {
  isDevelopment: (): boolean => {
    return getEnvironmentVariable('ENVIRONMENT') !== 'production';
  },
};
